<template>
  <div style="display: flex;flex-direction: column;align-items: center;justify-content: flex-start;width: 100%">
    <div id="mainContentWrapper" style="background-color: transparent; background-image: none; background-repeat: no-repeat;background-position:0 0; background:-moz-linear-gradient(top, none, none);background:-webkit-gradient(linear, left top, left bottom, from(none), to(none));background:-o-linear-gradient(top, none, none);background:-ms-linear-gradient(top, none, none);background:linear-gradient(top, none, none);;
     position: relative; width: 100%;min-width:1000px;background-size: auto;" bgScroll="none">
      <Header/>
      <Banner/>
      <div class="main-layout-wrapper" id="smv_AreaMainWrapper" style="background-color: transparent; background-image: none;
         background-repeat: no-repeat;background-position:0 0; background:-moz-linear-gradient(top, none, none);background:-webkit-gradient(linear, left top, left bottom, from(none), to(none));background:-o-linear-gradient(top, none, none);background:-ms-linear-gradient(top, none, none);background:linear-gradient(top, none, none);;background-size: auto;"
           bgscroll="none" tm="111">
        <div class="main-layout" id="tem-main-layout11" style="width: 100%;" tm="112">
          <div class="" id="smv_MainContent" rel="mainContentWrapper"
               style="width: 100%; min-height: 300px; position: relative; " tm="114">

            <div class="smvWrapper"
                 style="min-width:1000px;  position: relative; background-color: none; background-image: none; background-repeat: no-repeat; background:-moz-linear-gradient(top, none, none);background:-webkit-gradient(linear, left top, left bottom, from(none), to(none));background:-o-linear-gradient(top, none, none);background:-ms-linear-gradient(top, none, none);background:linear-gradient(top, none, none);;background-position:0 0;background-size:;"
                 bgscroll="none" tm="115" oriwidth="1710px" oriminwidth="1000px">
              <div class="smvContainer" id="smv_Main" cpid="32"
                   style="min-height:400px;width:1000px;height:1768px;  position: relative; " tm="116" oriwidth="1000px"
                   oriminwidth="0px">
                <div id="smv_con_12_41" ctype="text" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                     ccolor="Item1" areaid="" iscontainer="False" pvid="" tareaid="" re-direction="all" daxis="All"
                     isdeletable="True" style="height: 68px; width: 360px; left: 320px; top: 30px;z-index:3;" tm="117"
                     ctrl-location="main">
                  <div class="yibuFrameContent con_12_41  text_Style1  " style="overflow:hidden;;" tm="118">
                    <div id="txt_con_12_41" style="height: 100%;" tm="119">
                      <div class="editableContent" id="txtc_con_12_41" style="height: 100%; word-wrap:break-word;"
                           tm="120">
                        <p style="text-align:center" tm="121"><span style="font-family:Microsoft JhengHei"
                                                                    tm="122"><span style="font-size:20px"
                                                                                   tm="123">产品中心</span></span></p>

                        <p style="text-align:center" tm="124"><span style="color:#bdc3c7" tm="125"><span
                            style="line-height:1.5" tm="126"><span style="font-family:Microsoft JhengHei" tm="127"><span
                            style="font-size:18px" tm="128">PRODUCTS</span></span></span></span></p>

                      </div>
                    </div>
                  </div>
                </div>
                <div id="smv_con_61_34" ctype="listproduct" class="esmartMargin smartAbs " cpid="32" cstyle="Style2"
                     ccolor="Item0" areaid="Main" iscontainer="False" pvid="" tareaid="Main" re-direction="all"
                     daxis="All" isdeletable="True"
                     style="height: 363px; width: 1000px; left: 0px; top: 124px;z-index:2;" tm="130"
                     ctrl-location="main">
                  <div class="yibuFrameContent con_61_34  listproduct_Style2  " style="overflow:hidden;;" tm="131">
                    <div class="w-list xn-resize" tm="132">
                      <ul class="w-list-ul" id="ulList_con_61_34" data-title-autolines="1" data-desc-autolines="1"
                          tm="133">
                        <li class="w-list-item f-clearfix" tm="134">
                          <a href="/#/detail?id=1" target="_self" class="w-list-link" tm="135">
                            <div class="w-list-pic" tm="136">
                              <img src="../../public/img/29947401.jpg"
                                   class="w-listpic-in" autofill="ok" init="ok"
                                   style="width: auto; height: 280px; margin-left: -33.7727px;" tm="137">
                            </div>
                            <div class="w-list-bottom" tm="138">
                              <h5 class="w-list-title" style="height: 28px;" tm="139">克罗兔纳米雾化杯</h5>
                              <div class="w-list-desc " style="height: 20px;" tm="140">
                                克罗兔纳米雾化杯是一款小巧便携的纳米雾化杯，须与克罗兔空气雾化消毒片（0.5g装）搭配使用。甜筒采用先进的纳米雾化技术，雾量大、雾化效果好，并在极短时间内通过出雾口均匀地将雾气扩散到空气中，有效灭杀空气中的病毒、细菌，去除甲醛，净化室内空气，净享健康呼吸。
                              </div>
                            </div>
                          </a>
                        </li>
                        <li class="w-list-item f-clearfix" tm="143">
                          <a href="/#/detail?id=2" target="_self" class="w-list-link" tm="144">
                            <div class="w-list-pic" tm="145">
                              <img src="../../public/img/29946868.jpg"
                                   class="w-listpic-in" autofill="ok" init="ok"
                                   style="width: auto; height: 280px; margin-left: -22.2405px;" tm="146">
                            </div>
                            <div class="w-list-bottom" tm="147">
                              <h5 class="w-list-title" style="height: 28px;" tm="148">克罗兔纳米雾化器</h5>
                              <div class="w-list-desc " style="height: 20px;" tm="149">
                                克罗兔纳米雾化器采用纳米雾化技术，可通过先进的雾化装置及高强力的输送系统将液体以纯分子态快速释放到空气中。初见须与克罗兔空气雾化消毒片（1.0g装）搭配使用，可将消毒片完全溶解后的消毒液雾化为微纳米级的液滴，并在极短的时间内通过出雾口均匀地将雾气扩散到空气中，高效灭杀空气中的病毒、细菌，去除甲醛，实现360°的室内防护，净享健康呼吸。
                              </div>
                            </div>
                          </a>
                        </li>
                        <li class="w-list-item f-clearfix" tm="152">
                          <a href="/#/detail?id=3" target="_self" class="w-list-link" tm="153">
                            <div class="w-list-pic" tm="154">
                              <img src="../../public/img/28041944.png"
                                   class="w-listpic-in" autofill="ok" init="ok"
                                   style="width: auto; height: 280px; margin-left: -22px;" tm="155">
                            </div>
                            <div class="w-list-bottom" tm="156">
                              <h5 class="w-list-title" style="height: 28px;" tm="157">克罗兔空气雾化消毒片（1g装）</h5>
                              <div class="w-list-desc " style="height: 20px;" tm="158">
                                克罗兔空气雾化消毒片是以ClO₂为主要成分的消毒泡腾片，可快速溶于水，制成消毒液。本品与克罗兔纳米雾化器搭配使用，可将消毒液雾化为微纳米级液滴并快速扩散，有效杀灭空气中的病毒、细菌，去除甲醛，净化空气。
                              </div>
                            </div>
                          </a>
                        </li>
                        <li class="w-list-item f-clearfix" tm="161">
                          <a href="/#/detail?id=4" target="_self" class="w-list-link" tm="162">
                            <div class="w-list-pic" tm="163">
                              <img src="../../public/img/28041942.png"
                                   class="w-listpic-in" autofill="ok" init="ok"
                                   style="width: auto; height: 280px; margin-left: -22px;" tm="164">
                            </div>
                            <div class="w-list-bottom" tm="165">
                              <h5 class="w-list-title" style="height: 28px;" tm="166">克罗兔空气雾化消毒片（0.5g装）</h5>
                              <div class="w-list-desc " style="height: 20px;" tm="167">
                                克罗兔空气雾化消毒片是以ClO₂为主要成分的消毒产品，可快速溶于水，制成消毒液。本品（0.5g装）与克罗兔纳米雾化杯搭配使用，可将消毒液雾化为微纳米级的液滴并快速扩散，有效杀灭空气中的病毒、细菌，去除甲醛，净化空气。
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div id="smv_con_19_2" ctype="banner" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                     ccolor="Item0" areaid="" iscontainer="True" pvid="" tareaid="" re-direction="y" daxis="Y"
                     isdeletable="True" style="height: 353px; width: 100%; left: 0px; top: 593px;z-index:6;" tm="171"
                     ctrl-location="main">
                  <div class="yibuFrameContent con_19_2  banner_Style1  " style="overflow:visible;;" tm="172">
                    <div class="fullcolumn-inner smAreaC" id="smc_Area0" cid="con_19_2" style="width:1000px" tm="173"
                         oriwidth="1000px" oriminwidth="0px">
                      <div id="smv_con_20_0" ctype="area"
                           smanim="{&quot;delay&quot;:0.0,&quot;duration&quot;:1.0,&quot;direction&quot;:&quot;Left&quot;,&quot;animationName&quot;:&quot;slideIn&quot;,&quot;infinite&quot;:&quot;1&quot;}"
                           class="esmartMargin smartAbs animated" cpid="32" cstyle="Style1" ccolor="Item0"
                           areaid="Area0" iscontainer="True" pvid="con_19_2" tareaid="" re-direction="all" daxis="All"
                           isdeletable="True"
                           style="height: 291px; width: 215px; left: 2px; top: 42px; z-index: 2; opacity: 1;" tm="174"
                           ctrl-location="main" prevhisani="slideInLeft" sm-finished="true" smexecuted="1">
                        <div class="yibuFrameContent con_20_0  area_Style1  " style="overflow:visible;;" tm="175">
                          <div data-effect-name="enterTop" tm="176">
                            <div class="smAreaC" id="smc_Area0" cid="con_20_0" tm="177">
                              <div id="smv_con_22_48" ctype="image" class="esmartMargin smartAbs " cpid="32"
                                   cstyle="Style1" ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_20_0"
                                   tareaid="" re-direction="all" daxis="All" isdeletable="True"
                                   style="height: 110px; width: 110px; left: 140px; top: 36px;z-index:3;" tm="178"
                                   ctrl-location="main">
                                <div class="yibuFrameContent con_22_48  image_Style1  " style="overflow:visible;;"
                                     tm="179">
                                  <div class="w-image-box image-clip-wrap" data-filltype="2" id="div_con_22_48"
                                       style="width: 110px; height: 110px;" tm="180">
                                    <a target="_self" href="javascript:;" style="width: 100%; height: 100%;" tm="181">
                                      <img src="../../public/img/29946867.jpg"
                                           alt="" title="" id="img_smv_con_22_48" style="width: 110px; height:110px;"
                                           class="" tm="182">
                                    </a>
                                  </div>

                                </div>
                              </div>
                              <div id="smv_con_24_2" ctype="text" class="esmartMargin smartAbs " cpid="32"
                                   cstyle="Style1" ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_20_0"
                                   tareaid="" re-direction="all" daxis="All" isdeletable="True"
                                   style="height: 151px; width: 270px; left: 69px; top: 146px;z-index:5;" tm="184"
                                   ctrl-location="main">
                                <div class="yibuFrameContent con_24_2  text_Style1  " style="overflow:hidden;;"
                                     tm="185">
                                  <div id="txt_con_24_2" style="height: 100%;" tm="186">
                                    <div class="editableContent" id="txtc_con_24_2"
                                         style="height: 100%; word-wrap:break-word;" tm="187">
                                      <p style="text-align:justify" tm="188">&nbsp;</p>

                                      <p style="text-align:center" tm="189"><span style="font-size:20px"
                                                                                  tm="190">生活环境</span></p>

                                      <p style="text-align:center" tm="191">&nbsp;</p>

                                      <p style="text-align:center" tm="192">&nbsp;</p>

                                      <p style="text-align:center" tm="193"><span style="line-height:1.5" tm="194"><span
                                          style="font-size:16px"
                                          tm="195">在家庭、酒店、车内等室内环境中推荐使用克罗兔进行杀菌、消毒，营造健康的家庭环境。</span></span></p>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="smv_con_25_49" ctype="area"
                           smanim="{&quot;delay&quot;:0.5,&quot;duration&quot;:1.0,&quot;direction&quot;:&quot;Left&quot;,&quot;animationName&quot;:&quot;slideIn&quot;,&quot;infinite&quot;:&quot;1&quot;}"
                           class="esmartMargin smartAbs animated" cpid="32" cstyle="Style1" ccolor="Item0"
                           areaid="Area0" iscontainer="True" pvid="con_19_2" tareaid="" re-direction="all" daxis="All"
                           isdeletable="True"
                           style="height: 291px; width: 215px; left: 447px; top: 39px; z-index: 2; opacity: 1;" tm="197"
                           ctrl-location="main" prevhisani="slideInLeft" sm-finished="true" smexecuted="1">
                        <div class="yibuFrameContent con_25_49  area_Style1  " style="overflow:visible;;" tm="198">
                          <div data-effect-name="enterTop" tm="199">
                            <div class="smAreaC" id="smc_Area0" cid="con_25_49" tm="200">
                              <div id="smv_con_29_49" ctype="text" class="esmartMargin smartAbs " cpid="32"
                                   cstyle="Style1" ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_25_49"
                                   tareaid="" re-direction="all" daxis="All" isdeletable="True"
                                   style="height: 143px; width: 303px; left: -79px; top: 148px;z-index:5;" tm="201"
                                   ctrl-location="main">
                                <div class="yibuFrameContent con_29_49  text_Style1  " style="overflow:hidden;;"
                                     tm="202">
                                  <div id="txt_con_29_49" style="height: 100%;" tm="203">
                                    <div class="editableContent" id="txtc_con_29_49"
                                         style="height: 100%; word-wrap:break-word;" tm="204">
                                      <p tm="205">&nbsp;</p>

                                      <p style="text-align:center" tm="206"><span style="font-family:Microsoft YaHei"
                                                                                  tm="207"><span style="color:#333333"
                                                                                                 tm="208"><span
                                          style="font-size:20px" tm="209">办公&amp;学习环境</span></span></span></p>

                                      <p style="text-align:center" tm="210">&nbsp;</p>

                                      <p style="text-align:center" tm="211">&nbsp;</p>

                                      <p style="text-align:center" tm="212"><span style="font-size:16px" tm="213">在办公室、教室等环境</span><span
                                          style="line-height:1.5" tm="214"><span style="font-size:16px" tm="215">推荐使用克罗兔对周围的空气进行净化、消杀，为工作、学习环境的健康做保障。</span></span>
                                      </p>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div id="smv_con_62_6" ctype="image" class="esmartMargin smartAbs " cpid="32"
                                   cstyle="Style1" ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_25_49"
                                   tareaid="" re-direction="all" daxis="All" isdeletable="True"
                                   style="height: 110px; width: 110px; left: 12px; top: 40px;z-index:3;" tm="217"
                                   ctrl-location="main">
                                <div class="yibuFrameContent con_62_6  image_Style1  " style="overflow:visible;;"
                                     tm="218">
                                  <div class="w-image-box image-clip-wrap" data-filltype="2" id="div_con_62_6"
                                       style="width: 110px; height: 110px;" tm="219">
                                    <a target="_self" style="width: 100%; height: 100%;" tm="220">
                                      <img src="../../public/img/29947401.jpg"
                                           alt="" title="" id="img_smv_con_62_6" style="width: 110px; height:110px;"
                                           class="" tm="221">
                                    </a>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="smv_con_30_2" ctype="area"
                           smanim="{&quot;delay&quot;:1.5,&quot;duration&quot;:1.0,&quot;direction&quot;:&quot;Left&quot;,&quot;animationName&quot;:&quot;slideIn&quot;,&quot;infinite&quot;:&quot;1&quot;}"
                           class="esmartMargin smartAbs animated" cpid="32" cstyle="Style1" ccolor="Item0"
                           areaid="Area0" iscontainer="True" pvid="con_19_2" tareaid="" re-direction="all" daxis="All"
                           isdeletable="True"
                           style="height: 291px; width: 215px; left: 756px; top: 43px; z-index: 2; opacity: 1;" tm="223"
                           ctrl-location="main" prevhisani="slideInLeft" sm-finished="true" smexecuted="1">
                        <div class="yibuFrameContent con_30_2  area_Style1  " style="overflow:visible;;" tm="224">
                          <div data-effect-name="enterTop" tm="225">
                            <div class="smAreaC" id="smc_Area0" cid="con_30_2" tm="226">
                              <div id="smv_con_34_2" ctype="text" class="esmartMargin smartAbs " cpid="32"
                                   cstyle="Style1" ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_30_2"
                                   tareaid="" re-direction="all" daxis="All" isdeletable="True"
                                   style="height: 148px; width: 240px; left: -50px; top: 142px;z-index:5;" tm="227"
                                   ctrl-location="main">
                                <div class="yibuFrameContent con_34_2  text_Style1  " style="overflow:hidden;;"
                                     tm="228">
                                  <div id="txt_con_34_2" style="height: 100%;" tm="229">
                                    <div class="editableContent" id="txtc_con_34_2"
                                         style="height: 100%; word-wrap:break-word;" tm="230">
                                      <p tm="231">&nbsp;</p>

                                      <p style="text-align:center" tm="232"><span
                                          style="color:#333333; font-family:Microsoft YaHei" tm="233"><span
                                          style="font-size:20px" tm="234">公共环境</span></span></p>

                                      <p style="text-align:center" tm="235">&nbsp;</p>

                                      <p style="text-align:center" tm="236">&nbsp;</p>

                                      <p style="text-align:center" tm="237"><span style="font-size:16px"
                                                                                  tm="238">在车<span
                                          style="line-height:1.5"
                                          tm="239">站、地铁、电梯等人流密集的公共场所中推荐使用克罗兔进行空气消杀，防止人员交叉感染。</span></span></p>

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div id="smv_con_64_10" ctype="image" class="esmartMargin smartAbs " cpid="32"
                                   cstyle="Style1" ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_30_2"
                                   tareaid="" re-direction="all" daxis="All" isdeletable="True"
                                   style="height: 110px; width: 110px; left: 8px; top: 36px;z-index:3;" tm="241"
                                   ctrl-location="main">
                                <div class="yibuFrameContent con_64_10  image_Style1  " style="overflow:visible;;"
                                     tm="242">
                                  <div class="w-image-box image-clip-wrap" data-filltype="2" id="div_con_64_10"
                                       style="width: 110px; height: 110px;" tm="243">
                                    <a target="_self" style="width: 100%; height: 100%;" tm="244">
                                      <img src="../../public/img/29947459.jpg"
                                           alt="" title="" id="img_smv_con_64_10" style="width: 110px; height:110px;"
                                           class="" tm="245">
                                    </a>
                                  </div>


                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="smv_con_70_42" ctype="text" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                           ccolor="Item1" areaid="Area0" iscontainer="False" pvid="con_19_2" tareaid=""
                           re-direction="all" daxis="All" isdeletable="True"
                           style="height: 88px; width: 360px; left: 334px; top: 0px;z-index:3;" tm="247"
                           ctrl-location="main">
                        <div class="yibuFrameContent con_70_42  text_Style1  " style="overflow:hidden;;" tm="248">
                          <div id="txt_con_70_42" style="height: 100%;" tm="249">
                            <div class="editableContent" id="txtc_con_70_42" style="height: 100%; word-wrap:break-word;"
                                 tm="250">
                              <p style="text-align:center" tm="251">&nbsp;</p>

                              <p style="text-align:center" tm="252"><span style="font-family:Microsoft JhengHei"
                                                                          tm="253"><span style="font-size:20px"
                                                                                         tm="254">应用场景</span></span></p>

                              <p style="text-align:center" tm="255">&nbsp;</p>

                              <p style="text-align:center" tm="256"><span
                                  style="color:#bdc3c7; font-family:Microsoft JhengHei" tm="257"><span
                                  style="font-size:18px" tm="258">APPLICATIONS</span></span></p>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="bannerWrap_con_19_2" class="fullcolumn-outer"
                         style="position: absolute; top: 0px; bottom: 0px; left: -355px; width: 1710px;" tm="260">
                    </div>
                  </div>
                </div>
                <div id="smv_con_45_29" ctype="text" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                     ccolor="Item1" areaid="" iscontainer="False" pvid="" tareaid="" re-direction="all" daxis="All"
                     isdeletable="True" style="height: 69px; width: 360px; left: 319px; top: 996px;z-index:3;" tm="262"
                     ctrl-location="main">
                  <div class="yibuFrameContent con_45_29  text_Style1  " style="overflow:hidden;;" tm="263">
                    <div id="txt_con_45_29" style="height: 100%;" tm="264">
                      <div class="editableContent" id="txtc_con_45_29" style="height: 100%; word-wrap:break-word;"
                           tm="265">
                        <p style="text-align:center" tm="266"><span style="font-size:20px" tm="267"><span
                            style="line-height:1.5" tm="268"><span style="font-family:Microsoft JhengHei"
                                                                   tm="269">关于克罗兔</span></span></span></p>

                        <p style="text-align:center" tm="270"><span
                            style="color:#bdc3c7; font-family:Microsoft JhengHei; font-size:large" tm="271"><span
                            style="line-height:27px" tm="272">ABOUT&nbsp;<span style="text-align:center"
                                                                               tm="273">ClO2</span></span></span></p>

                      </div>
                    </div>
                  </div>
                </div>
                <div id="smv_con_46_12" ctype="area"
                     smanim="{&quot;delay&quot;:0.0,&quot;duration&quot;:1.0,&quot;direction&quot;:&quot;Left&quot;,&quot;animationName&quot;:&quot;slideIn&quot;,&quot;infinite&quot;:&quot;1&quot;}"
                     class="esmartMargin smartAbs animated" cpid="32" cstyle="Style1" ccolor="Item0" areaid=""
                     iscontainer="True" pvid="" tareaid="" re-direction="all" daxis="All" isdeletable="True"
                     style="height: 276px; width: 85px; left: 0px; top: 1081px; z-index: 7; opacity: 1;" tm="275"
                     ctrl-location="main" prevhisani="slideInLeft" sm-finished="true" smexecuted="1">
                  <div class="yibuFrameContent con_46_12  area_Style1  " style="overflow:visible;;" tm="276">
                    <div class="w-container" data-effect-name="enterTop" tm="277">
                      <div class="smAreaC" id="smc_Area0" cid="con_46_12" tm="278">
                        <div id="smv_con_47_49" ctype="text" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                             ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_46_12" tareaid=""
                             re-direction="all" daxis="All" isdeletable="True"
                             style="height: 228px; width: 48px; left: 17px; top: 35px;z-index:11;" tm="279"
                             ctrl-location="main">
                          <div class="yibuFrameContent con_47_49  text_Style1  " style="overflow:hidden;;" tm="280">
                            <div id="txt_con_47_49" style="height: 100%;" tm="281">
                              <div class="editableContent" id="txtc_con_47_49"
                                   style="height: 100%; word-wrap:break-word;" tm="282">
                                <p style="text-align:center" tm="283"><span style="text-align:center" tm="284"><span
                                    style="color:#999999" tm="285"><span style="font-size:36px" tm="286"><span
                                    style="line-height:1.2" tm="287"><span style="font-family:Microsoft JhengHei"
                                                                           tm="288"><span
                                    style="color:#999999; font-family:Microsoft JhengHei"
                                    tm="289">克罗兔</span></span></span></span></span></span></p>

                                <p style="text-align:center" tm="290"><span style="color:#999999" tm="291"><span
                                    style="font-size:36px" tm="292"><span style="line-height:1.2" tm="293"><span
                                    style="font-family:Microsoft JhengHei" tm="294">简</span></span></span></span></p>

                                <p style="text-align:center" tm="295"><span style="color:#999999" tm="296"><span
                                    style="font-size:36px" tm="297"><span style="line-height:1.2" tm="298"><span
                                    style="font-family:Microsoft JhengHei" tm="299">介</span></span></span></span></p>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="smv_con_49_36" ctype="image" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                     ccolor="Item0" areaid="" iscontainer="False" pvid="" tareaid="" re-direction="all" daxis="All"
                     isdeletable="True" style="height: 243px; width: 365px; left: 631px; top: 1104px;z-index:12;"
                     tm="301" ctrl-location="main">
                  <div class="yibuFrameContent con_49_36  image_Style1  " style="overflow:visible;;" tm="302">
                    <div class="w-image-box image-clip-wrap" data-filltype="0" id="div_con_49_36"
                         style="height: 243px; width: 365px;" tm="303">
                      <a target="_self" tm="304">
                        <img src="../../public/img/31020489.jpeg" alt=""
                             title="" id="img_smv_con_49_36" style="width: 365px; height:243px;" class="" tm="305">
                      </a>
                    </div>

                  </div>
                </div>
                <div id="smv_con_50_48" ctype="banner" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                     ccolor="Item0" areaid="" iscontainer="True" pvid="" tareaid="" re-direction="y" daxis="Y"
                     isdeletable="True" style="height: 308px; width: 100%; left: 0px; top: 1394px;z-index:10;" tm="307"
                     ctrl-location="main">
                  <div class="yibuFrameContent con_50_48  banner_Style1  " style="overflow:visible;;" tm="308">
                    <div class="fullcolumn-inner smAreaC" id="smc_Area0" cid="con_50_48" style="width:1000px" tm="309"
                         oriwidth="1000px" oriminwidth="0px">
                      <div id="smv_con_51_15" ctype="text" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                           ccolor="Item1" areaid="Area0" iscontainer="False" pvid="con_50_48" tareaid=""
                           re-direction="all" daxis="All" isdeletable="True"
                           style="height: 69px; width: 360px; left: 320px; top: 51px;z-index:3;" tm="310"
                           ctrl-location="main">
                        <div class="yibuFrameContent con_51_15  text_Style1  " style="overflow:hidden;;" tm="311">
                          <div id="txt_con_51_15" style="height: 100%;" tm="312">
                            <div class="editableContent" id="txtc_con_51_15" style="height: 100%; word-wrap:break-word;"
                                 tm="313">
                              <p style="text-align:center" tm="314"><span style="font-family:Microsoft JhengHei"
                                                                          tm="315"><span
                                  style="font-size:20px; line-height:30px" tm="316">联系我们</span></span></p>

                              <p style="text-align:center" tm="317"><span
                                  style="color:#bdc3c7; font-family:Microsoft JhengHei; font-size:large" tm="318"><span
                                  style="line-height:27px" tm="319">CONTACT US</span></span></p>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="smv_con_66_38" ctype="companyinfo" class="esmartMargin smartAbs " cpid="32"
                           cstyle="Style3" ccolor="Item0" areaid="Area0" iscontainer="False" pvid="con_50_48" tareaid=""
                           re-direction="all" daxis="All" isdeletable="True"
                           style="height: 167px; width: 1000px; left: 2px; top: 120px;z-index:6;" tm="321"
                           ctrl-location="main">
                        <div class="yibuFrameContent con_66_38  companyinfo_Style3  " style="overflow:hidden;;"
                             tm="322">
                          <ul class="w-company-info iconStyle3" tm="323">
                            <li class="company-info-item" style="width:25%" tm="324">
                              <a href="mailto:clo2health@163.com" tm="325">
                                <div class="company-info-icon " tm="326">
                                  <i class="ltd-icon1 gs-youxiang" tm="327"></i>
                                </div>
                                <div class="company-text" tm="328">
                                  <div class="company-info-title " style="white-space:pre" tm="329">邮箱</div>
                                  <div class="company-info-text" tm="330">clo2health@163.com</div>
                                </div>
                              </a>
                            </li>
                            <li class="company-info-item" style="width:25%" tm="331">
                              <a href="javascript:void(0)" tm="332">
                                <div class="company-info-icon " tm="333">
                                  <i class="ltd-icon1 gs-dizhi" tm="334"></i>
                                </div>
                                <div class="company-text" tm="335">
                                  <div class="company-info-title " style="white-space:pre" tm="336">地址</div>
                                  <div class="company-info-text" tm="337">重庆市江津区双福新区联东U谷5号楼</div>
                                </div>
                              </a>
                            </li>
                            <li class="company-info-item" style="width:25%" tm="338">
                              <a href="tel:023-47897989" tm="339">
                                <div class="company-info-icon " tm="340">
                                  <i class="ltd-icon1 gs-dianhua" tm="341"></i>
                                </div>
                                <div class="company-text" tm="342">
                                  <div class="company-info-title " style="white-space:pre" tm="343">电话</div>
                                  <div class="company-info-text" tm="344">023-47897989</div>
                                </div>
                              </a>
                            </li>
                            <li class="company-info-item" style="width:25%" tm="345">
                              <a href="tel:18524499638" tm="346">
                                <div class="company-info-icon " tm="347">
                                  <i class="ltd-icon1 gs-shouji" tm="348"></i>
                                </div>
                                <div class="company-text" tm="349">
                                  <div class="company-info-title " style="white-space:pre" tm="350">手机</div>
                                  <div class="company-info-text" tm="351">18524499638</div>
                                </div>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div id="bannerWrap_con_50_48" class="fullcolumn-outer"
                         style="position: absolute; top: 0px; bottom: 0px; left: -355px; width: 1710px;" tm="353">
                    </div>

                  </div>
                </div>
                <div id="smv_con_67_1" ctype="text" class="esmartMargin smartAbs " cpid="32" cstyle="Style1"
                     ccolor="Item4" areaid="" iscontainer="False" pvid="" tareaid="" re-direction="all" daxis="All"
                     isdeletable="True" style="height: 271px; width: 521px; left: 96px; top: 1095px;z-index:13;"
                     tm="355" ctrl-location="main">
                  <div class="yibuFrameContent con_67_1  text_Style1  " style="overflow:hidden;;" tm="356">
                    <div id="txt_con_67_1" style="height: 100%;" tm="357">
                      <div class="editableContent" id="txtc_con_67_1" style="height: 100%; word-wrap:break-word;"
                           tm="358">
                        <p tm="359"><span style="line-height:1.75" tm="360"><span style="letter-spacing:1.5px" tm="361"><span
                            style="font-size:16px" tm="362">在新冠疫情蔓延之际，市场上缺少有效的民用空气消杀产品。常用的75%酒精、84消毒液的消杀对象局限为物体表面，不适用于空气消杀。为弥补市场空白，助力疫情防控，我司自主研发出基于ClO2的克罗兔®系列空气消杀产品。产品主要成分ClO2是经世界卫生组织（WHO）、世界粮食组织（FAO）以及食品添加剂专家委员会（JECFA）认证的A1级消毒剂，适用于自来水、物体表面、食品、医疗器具、瓜果蔬菜、空气环境的杀菌消毒，并先后用于“9.11”事件后炭疽热疫源、“非典”病毒及埃博拉病毒的消杀，为国家卫健委在新冠肺炎疫情期间推荐使用的空气消杀剂。</span></span></span>
                        </p>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <input type="hidden" name="__RequestVerificationToken" id="token__RequestVerificationToken"
                   value="YaEFMyLcdb5h118ip8KcKVpo1ADf1RmvdQLfrR7QxRXOF8k9NN-uXIxxDCt7_7rsLexcCtL1nN3hNlEz-aRswbUf32_MGVJ7_DJDMSAZo001"
                   tm="364">
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header"
import Banner from "@/components/Banner";
import Footer from "@/components/Footer";

export default {
  name: 'HomeView',
  components: {
    Footer,
    Banner,
    Header
  }
}
</script>
<style>
  .w-list {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
  .w-list-ul {
    margin: 0;
    margin-left: -15px;
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .w-list-item {
    padding: 0;
    margin: 0;
    margin-left: 15px;
    margin-bottom: 15px;
    display: inline-block;
    float: left;
    width: 236px;
    min-width: 100px;
    overflow: hidden;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    background-color: #fff;
    background-image: none;
    background-repeat: repeat;
    background-position: 0 0;
    background: -moz-linear-gradient(top, none, none);
    background: -o-linear-gradient(top, none, none);
    background: linear-gradient(top, none, none);
    background: -webkit-gradient(linear, left top, left bottom, from(none), to(none));
    border-top-width: 1px;
    border-top-color: #f5f5f5;
    border-top-style: solid;
    border-bottom-color: #f5f5f5;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-right-width: 1px;
    border-right-color: #f5f5f5;
    border-right-style: solid;
    border-left-color: #f5f5f5;
    border-left-style: solid;
    border-left-width: 1px;
    list-style: none;
    -webkit-transition: all 200ms linear;
    -moz-transition: all 200ms linear;
    -o-transition: all 200ms linear;
    -ms-transition: all 200ms linear;
    transition: all 200ms linear;
  }
  .w-list-link {
    width: 100%;
    height: 100%;
    display: block;
    border-top-left-radius: 0;
    -webkit-border-top-left-radius: 0;
    -moz-border-top-left-radius: 0;
    border-top-right-radius: 0;
    -webkit-border-top-right-radius: 0;
    -moz-border-top-right-radius: 0;
    text-decoration: none;
    outline: none;
  }
  .w-list-pic {
    padding: 0;
    margin: 0;
    width: 236px;
    min-width: 100px;
    height: 280px;
    vertical-align: top;
    overflow: hidden;
  }
  .w-list-bottom {
    padding: 0 10px 10px 10px;
    margin: 0;
  }
  .w-list-title {
    margin: 0;
    margin-top: 5px;
    padding: 0;
    line-height: 28px;
    height: 28px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    font-size: 14px;
    color: #404040;
    text-align: center;
    font-weight: normal;
    font-style: normal;
    text-decoration: none;
    font-family: 'Microsoft YaHei';
    transition: color 200ms linear;
  }
  .w-list-desc {
    height: 20px;
    line-height: 20px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    font-size: 12px;
    color: #999;
    text-align: center;
    font-weight: normal;
    font-style: normal;
    text-decoration: none;
    font-family: 'Microsoft YaHei';
  }
  .fullcolumn-outer {
    background-color: #F5F5F5;
    background-image: none;
    background-position: left top;
    background-repeat: repeat;
    background: -moz-linear-gradient(top, none, none);
    background: -o-linear-gradient(top, none, none);
    background: linear-gradient(top, none, none);
    background: -webkit-gradient(linear, left top, left bottom, from(none), to(none));
    background-size: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    z-index: -1;
  }
  .w-container {
    border-radius: 0px;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-right: 1px solid #cccccc;
    border-top: 1px solid #cccccc;
    border-bottom: 1px solid #cccccc;
    border-left: 1px solid #cccccc;
    border-radius: 0px;
    background-color: transparent;
    background-image: none;
    background-repeat: repeat;
    background-position: 0 0;
    background: -moz-linear-gradient(top, none, none);
    background: -o-linear-gradient(top, none, none);
    background: -ms-linear-gradient(top, none,none);
    background: linear-gradient(top, none, none);
    background: -webkit-gradient(linear, left top, left bottom, from(none), to(none));
    background-size: auto;
    -moz-box-shadow: 0 0 0 transparent;
    -webkit-box-shadow: 0 0 0 transparent;
    -ms-box-shadow: 0 0 0 transparent;
    -o-box-shadow: 0 0 0 transparent;
    box-shadow: 0 0 0 transparent;
    position: absolute;
    left: 0px;
    top: 0px;
    bottom: 0px;
    right: 0px;
  }
  .w-company-info {
    text-align: center;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .company-info-item {
    margin-bottom: 20px;
    float: left;
  }
  .company-info-item a {
    font-family: 'Microsoft YaHei';
    color: #000000;
    font-size: 14px;
  }
  .company-info-icon {
    display: inline-block;
    *display: inline;
    *zoom: 1;
    width: 48px;
  }
  .company-text {
    margin-top: 10px;
  }
  .ltd-icon1 {
    color: #666;
    font-size: 48px;
    font-family: "company-icon" !important;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
  }
  .company-info-title {
    color: #000000;
    font-size: 24px;
    line-height: 50px;
  }
  .company-info-text {
    font-family: 'Microsoft YaHei';
    line-height: 16px;
    font-weight: 400;
    font-style: normal;
    text-decoration: none;
  }
</style>
